export const LANDING = '/';
export const CONCEPT = '/konzept';
export const ARCHITECTS = '/architekten';
export const CONTACT = '/kontakt';